import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Title from '../title/Title';
import EirButton from '../eir-button/EirButton';
import Subtitle from '../subtitle/Subtitle';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer'

class ThreeTileBanner extends Component {

  constructor(props) {
    super(props);

    let aspectRatio = '10-16';

    if(this.props.height == 100) {
      aspectRatio = '10-16';
    }
    if(this.props.height == 75) {
      aspectRatio = '10-12';
    }
    if(this.props.height == 50) {
      aspectRatio = '10-8';
    }

    this.state = {
      aspectRatio: aspectRatio
    };
  }
  render() {

    return (
      <Container fluid={this.props.fluid} className={'eir-three-tile-banner ' + this.props.fluid ? 'p-0' : 'mb-6 mt-6'}>
        <Row noGutters>
          {this.props.tiles.map(tile => {
            return (
              <Col xs="12" md="4">
                <AspectRatioContainer xs={this.state.aspectRatio} className={'eir-theme-' + (tile.theme ? tile.theme : 'default')} >
                  <img className="img-fluid position-absolute w-100" src={tile.image.path} alt={tile.image.description}/>
                  <div className="eir-h-33 d-flex flex-column justify-content-center align-items-center text-center">

                    <Title title={tile.title} />

                    <Subtitle text={tile.text} />

                    {tile.cta &&
                      <EirButton {...tile.cta} />
                    }

                  </div>

                </AspectRatioContainer>
              </Col>
            );
          })
          }
        </Row>
      </Container>
    );
  }
}

export default ThreeTileBanner;
